import { createAction } from 'redux-actions';
import { TOGGLE_SIDEBAR, SET_IS_EXPANDED, INIT_VISIBILITY, TOGGLE_SIDEBAR_CLOSE_BUTTON } from './consts';
import { getCookie } from '../../../utils/cookie';
import { DEFAULT_VISIBILITY_STATE } from '../const';

export const toggleSidebar = createAction(TOGGLE_SIDEBAR.ACTION);
export const setIsExpanded = createAction(SET_IS_EXPANDED.ACTION);
export const initVisibility = () => {
	let isExpanded = getCookie('sidebar_isExpandedView');
	const hasStoredValue = typeof isExpanded !== 'undefined' && isExpanded !== null;
	isExpanded = hasStoredValue ? JSON.parse(isExpanded) : DEFAULT_VISIBILITY_STATE;

	return {
		type: INIT_VISIBILITY.ACTION,
		payload: isExpanded,
	};
};

export const toggleSidebarCloseButton = createAction(TOGGLE_SIDEBAR_CLOSE_BUTTON.ACTION);
